import { createElement } from 'react';
import {
    AUDIT_AVATAR_NAME,
    CURATIVE_AVATARS_NAMES,
    DEFAULT_MAPPER,
    GLOBAL_NOTE_MAPPER,
    TREATMENT_AVATARS_NAMES,
} from '@/utils/CONST';
import GlobalNoteResolver from '@/components/common/notes/global-note-resolver/global-note-resolver';
import DisordersTreatmentNote from '@/components/common/notes/disorders-treatment-note/disorders-treatment-note';

const DISORDERS_TREATMENT_NOTE = 'disorders-treatment-note';

const noteResolverInscriptions: any = {
    [DEFAULT_MAPPER]: GlobalNoteResolver,
    [GLOBAL_NOTE_MAPPER]: GlobalNoteResolver,
    [DISORDERS_TREATMENT_NOTE]: DisordersTreatmentNote,
};

interface Props {
    type: string;
    avatarName: string;
    [key: string]: any;
}

const NoteResolver = ({ type, avatarName, ...restProps }: Props) => {
    const disordersTreatmentNames = { ...CURATIVE_AVATARS_NAMES, ...TREATMENT_AVATARS_NAMES, AUDIT_AVATAR_NAME };

    if (Object.values(disordersTreatmentNames).includes(avatarName)) {
        return createElement(noteResolverInscriptions[DISORDERS_TREATMENT_NOTE], {
            avatarName,
            ...restProps,
        });
    }

    return createElement(noteResolverInscriptions[type] ?? noteResolverInscriptions[DEFAULT_MAPPER], restProps);
};

export default NoteResolver;
